import React from 'react';
import { Routes, Route } from 'react-router-dom';

const AppRoutes = ({ 
  HomePage, 
  HomesForSalePage, 
  RentalPropertiesPage, 
  LandDevelopmentPage, 
  ContactPage, 
  ThankYouPage,
  TestimonialsPage,
  BlogPage,
  BlogPostPage,
  LandDevelopmentBlogPage,
  NotFoundPage 
}) => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/homes-for-sale" element={<HomesForSalePage />} />
      <Route path="/rental-properties" element={<RentalPropertiesPage />} />
      <Route path="/land-development" element={<LandDevelopmentPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/testimonials" element={<TestimonialsPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:id" element={<BlogPostPage />} />
      <Route path="/blog/land-development" element={<LandDevelopmentBlogPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;